/* eslint-disable max-len */
import { defineMessages } from '@skippay/core/i18n/intl';

export default defineMessages({
	'validationErrors.invalid': {
		id: 'validationErrors.invalid',
		description: 'Validation errors - invalid',
		defaultMessage: 'Neplatná hodnota.',
	},
	'validationErrors.maximum': {
		id: 'validationErrors.maximum',
		description: 'Validation errors - maximum',
		defaultMessage: 'Překročeno maximum.',
	},
	'validationErrors.minimum': {
		id: 'validationErrors.minimum',
		description: 'Validation errors - minimum',
		defaultMessage: 'Nedosaženo minimum.',
	},
	'validationErrors.required': {
		id: 'validationErrors.required',
		description: 'Validation errors - required',
		defaultMessage: 'Toto pole je povinné.',
	},
	'validationErrors.format.email': {
		id: 'validationErrors.format.email',
		description: 'Validation errors - format - email',
		defaultMessage: 'Vámi zadaný e-mail má špatný tvar.',
	},
	'validationErrors.format.phone': {
		id: 'validationErrors.format.phone',
		description: 'Validation errors - format - phone',
		defaultMessage: 'Telefonní číslo musí být zadáno ve formátu (+420)111222333',
	},
});
